import { MapPin } from "lucide-react";
import { Reveal } from "./Reveal";

const STATES = [
  {
    state: "New Jersey",
    counties: ["Bergen", "Essex", "Middlesex", "Monmouth", "Camden", "Ocean", "Mercer", "Burlington"],
    testid: "coverage-card-nj",
  },
  {
    state: "Delaware",
    counties: ["New Castle", "Kent", "Sussex"],
    testid: "coverage-card-de",
  },
  {
    state: "Pennsylvania",
    counties: ["Bucks", "Chester", "Delaware County", "Montgomery", "Philadelphia", "Lancaster"],
    testid: "coverage-card-pa",
  },
];

export const Coverage = () => (
  <section id="coverage" className="border-t border-white/10 bg-ink2/50 py-20 lg:py-32" data-testid="coverage-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-8">
      <Reveal>
        <p className="mb-4 font-mono text-xs font-bold uppercase tracking-[0.3em] text-orange-500">
          Tri-State Service Area
        </p>
        <h2 className="max-w-3xl font-display text-4xl font-extrabold uppercase leading-[0.95] text-white sm:text-5xl lg:text-6xl">
          Local Crews. <span className="text-orange-500">Three States.</span>
        </h2>
        <p className="mt-5 max-w-2xl text-base text-slate-400">
          Same-week inspections across the region. If your county is listed, we
          can be on your roof fast — and emergency storm response runs 7 days a
          week.
        </p>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-8 lg:grid-cols-3">
        {STATES.map((s, i) => (
          <Reveal key={s.state} delay={i * 0.12}>
            <div
              data-testid={s.testid}
              className="group h-full rounded-2xl border border-white/10 bg-ink p-6 transition-all duration-300 hover:-translate-y-1.5 hover:border-orange-500/40 sm:p-8"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-orange-500/10">
                  <MapPin className="h-5 w-5 text-orange-500" />
                </span>
                <h3 className="font-display text-2xl font-bold uppercase text-white sm:text-3xl">
                  {s.state}
                </h3>
              </div>
              <div className="mt-6 flex flex-wrap gap-2">
                {s.counties.map((c) => (
                  <span
                    key={c}
                    className="rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-xs font-semibold text-slate-300"
                  >
                    {c}
                  </span>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p className="mt-10 text-sm text-slate-500" data-testid="coverage-note">
          Don't see your county? <a href="#quote" className="font-semibold text-orange-500 hover:underline">Ask us</a> — we regularly take on projects beyond these lines.
        </p>
      </Reveal>
    </div>
  </section>
);
